import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import GroupItem from '../../../Domain/UserGroup/GroupItem';
import GroupService from '../../../Services/UserGroup/GroupService';

export default class EditGroupWindowDescription {
  static titleForCreate = 'Create New Group';
  static titleForEdit = 'Edit Group';
  static itemType = GroupItem;
  static serviceFunction = (item) => {
    return item.GroupId ? GroupService.SaveEditedGroup(item) : GroupService.CreateNewGroup(item);
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Description',
          label: 'Description *',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
        }
      ],
    },
  ];
}
